<div class="multi-column-wrapper" *ngIf="data">
    <div class="multi-column-item" *ngFor="let text of data.multiColumnText">
        <finder-generic-text [data]="text"></finder-generic-text>
    </div>
</div>
